import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconX = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--x")} iconColor={color} size={size} width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <defs>
          <path d="M5.293 5.293a1 1 0 0 1 1.414 0L12 10.585l5.293-5.292a1 1 0 0 1 1.32-.083l.094.083a1 1 0 0 1 0 1.414L13.415 12l5.292 5.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.414 0L12 13.415l-5.293 5.292a1 1 0 0 1-1.32.083l-.094-.083a1 1 0 0 1 0-1.414L10.585 12 5.293 6.707a1 1 0 0 1-.083-1.32z" id="icon--centivo--x"/>
      </defs>
      <g fill="none" fillRule="evenodd">
          <use fill="currentColor" xlinkHref="#icon--centivo--x"/>
      </g>
  </IconWrapper>
)
